import {BaseViewModel} from "../../../../../../infrastructure/models/base-view-model";
import {PlayersStatisticsTableColumnViewModel} from "../columns/players-statistics.table.column.view-model";
import {PlayersStatisticsTableRowValueViewModel} from "./values/players-statistics.table.row.value.view-model";
import {PlayersStatisticsTableRowDomainModel} from "./players-statistics.table.row.domain-model";
import {PlayersStatisticsTableRowValueDomainModel} from "./values/players-statistics.table.row.value.domain-model";

export class PlayersStatisticsTableRowViewModel extends BaseViewModel {
  domainModel: PlayersStatisticsTableRowDomainModel;
  columns: Array<PlayersStatisticsTableColumnViewModel>;

  constructor(domainModel: PlayersStatisticsTableRowDomainModel, columns: Array<PlayersStatisticsTableColumnViewModel>) {
    super(domainModel);

    this.columns = columns;
  }

  get values(): Array<PlayersStatisticsTableRowValueViewModel> {
    const values: Array<PlayersStatisticsTableRowValueViewModel> = this.columns?.map((column: PlayersStatisticsTableColumnViewModel) => {
      const valueDomainModel: PlayersStatisticsTableRowValueDomainModel = this.domainModel.values?.find((value: PlayersStatisticsTableRowValueDomainModel) => value.columnNum === column.num);
      if (valueDomainModel) {
        const columnName = column.shortName;
        const value: PlayersStatisticsTableRowValueViewModel = new PlayersStatisticsTableRowValueViewModel(valueDomainModel, columnName, column.isGraphic, column.columnGroup)
        return value;
      }
      return null;

    });

    const valuesByGroup = values.groupBy(value => value?.groupColumnNumber);

    return valuesByGroup?.size > 1 ? Array.from(valuesByGroup.values()) : values;
  }

  get hasValues(): Boolean {
    const values: Array<PlayersStatisticsTableRowValueViewModel> = this.domainModel.values?.filter(value => !!value)?.length > 0;

    return values;
  }
}
